// src/utils/domainUtils.js - Centralized domain and URL management

/**
 * Get the appropriate base URL based on current environment and hostname
 */
export const getBaseUrl = () => {
  const hostname = window.location.hostname;
  
  if (hostname === 'localhost') {
    return 'http://localhost:3000';
  } else if (hostname === 'wispin.co' || hostname === 'www.wispin.co') {
    return 'https://wispin.co';
  } else {
    // Fallback for Vercel or other deployments
    return process.env.REACT_APP_PRODUCTION_URL || 'https://wishlist-spin.vercel.app';
  }
};

/**
 * Get the production domain for the current environment
 */
export const getProductionDomain = () => {
  const hostname = window.location.hostname;
  
  // If we're on production domain, use it
  if (hostname === 'wispin.co' || hostname === 'www.wispin.co') {
    return 'https://wispin.co';
  }
  
  // Otherwise use Vercel as fallback
  return 'https://wishlist-spin.vercel.app';
};

/**
 * Generate a share URL for a given token
 */
export const generateShareUrl = (token) => {
  if (!token) return '';
  return `${getBaseUrl()}/shared/${token}`;
};

/**
 * Generate an invitation URL for a given token
 */
export const generateInvitationUrl = (token) => {
  if (!token) return '';
  return `${getBaseUrl()}/invite/${token}`;
};

/**
 * Get OG image URL for meta tags
 */
export const getOgImageUrl = () => {
  return `${getProductionDomain()}/og-image.png?v=${Date.now()}`;
};